import {
  Rating as MuiRating,
  RatingProps as MuiRatingProps
} from '@mui/material'

import EmptyRatingSmallIcon from 'app/assets/icons/rating/empty-rating-small-star.svg'
import EmptyRatingIcon from 'app/assets/icons/rating/empty-rating-star.svg'
import RatingSmallIcon from 'app/assets/icons/rating/rating-small-star.svg'
import RatingIcon from 'app/assets/icons/rating/rating-star.svg'

export interface RatingProps extends Omit<MuiRatingProps, 'onChange'> {
  onChange?: (value: number) => void
}

const Rating: RFC<RatingProps> = ({ onChange, ...props }) => {
  const isSmallSize = props.size === 'small'

  const emptyIcon = isSmallSize ? <EmptyRatingSmallIcon /> : <EmptyRatingIcon />
  const icon = isSmallSize ? <RatingSmallIcon /> : <RatingIcon />

  return (
    <MuiRating
      emptyIcon={emptyIcon}
      icon={icon}
      sx={{ height: isSmallSize ? 18 : 55 }}
      onChange={(_, value) => {
        if (onChange) onChange(value || 0)
      }}
      {...props}
    />
  )
}

export default Rating
